import { COMPONENT_TYPES } from '../../../constants';
import AssetHistoryComponent from './AssetHistory.component';
import AssetHistoryEditor from './AssetHistory.editor';
import AssetHistoryProperties from './AssetHistory.properties';
import { registerComponent } from '../registry';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.ASSET_HISTORY,
  component: AssetHistoryComponent,
  editorComponent: AssetHistoryEditor,
  properties: AssetHistoryProperties,
  defaultProps: {
    // 기본 속성 정의
    style: {
      padding: '30px 0',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Noto Sans KR, sans-serif',
      margin: '0 auto',
      minHeight: '300px'
    },
    componentProps: {
      title: '자산 내역',
      emptyText: '자산 내역이 없습니다.'
    },
    className: 'mileage-history-wrapper padding-tb-40'
  },
  category: 'user',
  icon: '💰',
  name: '자산 내역'
});

// 컴포넌트 및 타입 내보내기
export { default as AssetHistoryComponent } from './AssetHistory.component';
export { default as AssetHistoryEditor } from './AssetHistory.editor';
export { default as AssetHistoryProperties } from './AssetHistory.properties';
export * from './AssetHistory.types'; 